import { useEffect, useState } from "react";
import type { PaymentRecord } from "../mocks/payments";
import {
  getPayments,
  rehydratePayments,
  setAllPayments,
  subscribePayments,
} from "../store/paymentsStore";

export function usePayments() {
  const [payments, setPayments] = useState<PaymentRecord[]>(() => getPayments());

  useEffect(() => {
    void rehydratePayments();

    const unsubscribe = subscribePayments(() => {
      setPayments(getPayments());
    });

    setPayments(getPayments());

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    payments,
    setAllPayments,
  };
}